(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const WA_NUMBER = '96171312153';

  let config = { moneyFormat: '${{amount}}', addToCart: 'Add to Cart' };
  try { Object.assign(config, JSON.parse($('[data-hm-pdp-config]').textContent)); } catch (e) {}

  const money = cents => {
    const a = (cents || 0) / 100;
    return config.moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      if (k === 'amount_no_decimals') return Math.round(a).toLocaleString('en-US');
      if (k === 'amount_with_comma_separator') return a.toFixed(2).replace('.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return Math.round(a).toLocaleString('de-DE');
      return a.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }).replace(/<[^>]*>/g, '');
  };

  function initProduct(section, isMain) {
    const jsonEl = $('[data-product-json]', section);
    const master = $('[data-product-master-select]', section);
    if (!jsonEl || !master) return;
    let product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    const variants = product.variants || [];
    const optionCount = (product.options || []).length;
    const selectors = $$('[data-product-option-selector]', section);
    const atcBtn = $('[data-product-add-to-cart]', section);

    const selectorsFor = i => selectors.filter(el => el.dataset.index === 'option' + (i + 1));
    const readOpts = () => Array.from({ length: optionCount }, (_, i) => {
      const els = selectorsFor(i);
      const el = els.find(e => e.type !== 'radio' || e.checked);
      return el ? el.value : null;
    });
    const findVariant = opts => variants.find(v => v.options.every((o, k) => o === opts[k]));
    const currentVariant = () => variants.find(v => String(v.id) === String(master.value)) || findVariant(readOpts()) || variants[0];

    const applyOpts = opts => {
      let last = null;
      opts.forEach((val, i) => selectorsFor(i).forEach(el => {
        if (el.type === 'radio') el.checked = el.value === val; else el.value = val;
        last = el;
      }));
      if (last) last.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const pick = (i, value) => {
      const opts = readOpts();
      opts[i] = value;
      let v = findVariant(opts);
      if (!v || !v.available) {
        const score = c => c.options.reduce((s, o, k) => s + (o === opts[k] ? 1 : 0), 0) + (c.available ? 100 : 0);
        const best = variants.filter(c => c.options[i] === value).sort((a, b) => score(b) - score(a))[0];
        if (best && (!v || best.available)) v = best;
      }
      applyOpts(v ? v.options : opts);
    };

    $$('[data-hm-opt]', section).forEach(group => {
      const i = Number(group.dataset.index);
      group.addEventListener('click', e => {
        const btn = e.target.closest('[data-hm-value]');
        if (btn) pick(i, btn.dataset.hmValue);
      });
      group.addEventListener('keydown', e => {
        const keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
        if (!(e.key in keys)) return;
        const btns = $$('[data-hm-value]', group);
        const idx = btns.indexOf(document.activeElement);
        if (idx < 0) return;
        e.preventDefault();
        const next = btns[(idx + keys[e.key] + btns.length) % btns.length];
        pick(i, next.dataset.hmValue);
        next.focus();
      });
    });

    const wa = $('[data-hm-wa]', section);
    const updateWhatsApp = v => {
      if (!wa || !v) return;
      const variantLabel = product.has_only_default_variant ? '' : ` (${v.title})`;
      const intro = v.available ? "Hi HolyMoly! I'd like to order:" : 'Hi HolyMoly! Will this be back in stock soon?';
      const msg = `${intro}\n${wa.dataset.title}${variantLabel} – ${money(v.price)}\n${wa.dataset.url}?variant=${v.id}`;
      wa.href = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(msg)}`;
      const label = $('span', wa);
      if (label) label.textContent = v.available ? 'Order on WhatsApp' : 'Ask about restock on WhatsApp';
    };

    const sticky = isMain ? $('[data-hm-sticky]') : null;
    const stickyBtn = sticky && $('[data-hm-sticky-btn]', sticky);
    const updateSticky = v => {
      if (!sticky || !v) return;
      $('[data-hm-sticky-price]', sticky).textContent = money(v.price);
      const vt = $('[data-hm-sticky-variant]', sticky);
      if (vt) vt.textContent = product.has_only_default_variant ? '' : ` · ${v.title}`;
      const img = $('[data-hm-sticky-img]', sticky);
      const src = v.featured_image && v.featured_image.src;
      if (img && src) img.src = src + (src.includes('?') ? '&' : '?') + 'width=120';
      stickyBtn.textContent = v.available ? config.addToCart : 'Notify me';
      stickyBtn.classList.toggle('is-soldout', !v.available);
    };

    const refresh = () => {
      const opts = readOpts();
      $$('[data-hm-opt]', section).forEach(group => {
        const i = Number(group.dataset.index);
        const label = $('[data-hm-opt-value]', group);
        if (label) label.textContent = opts[i] || '';
        $$('[data-hm-value]', group).forEach(btn => {
          const val = btn.dataset.hmValue;
          const selected = val === opts[i];
          btn.setAttribute('aria-checked', selected ? 'true' : 'false');
          btn.tabIndex = selected ? 0 : -1;
          const test = opts.slice();
          test[i] = val;
          const exact = findVariant(test);
          const available = exact ? exact.available : variants.some(v => v.options[i] === val && v.available);
          btn.classList.toggle('is-soldout', !available);
          const so = $('.hm-sw__so', btn);
          if (so) so.textContent = available ? '' : ' – sold out';
        });
      });
      const v = findVariant(opts) || currentVariant();
      updateWhatsApp(v);
      updateSticky(v);
    };

    section.addEventListener('variantChange', () => setTimeout(refresh, 0));
    master.addEventListener('change', () => setTimeout(refresh, 0));
    refresh();

    if (sticky && atcBtn) {
      const target = atcBtn.closest('form') || atcBtn;
      const setVisible = on => {
        sticky.classList.toggle('is-visible', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        stickyBtn.tabIndex = on ? 0 : -1;
        document.body.classList.toggle('hm-sticky-on', on);
      };
      // Scroll check instead of IntersectionObserver: a fast fling can jump past the form without an intersection change.
      let ticking = false, shown = null;
      const check = () => {
        ticking = false;
        const on = target.getBoundingClientRect().bottom < 0;
        if (on !== shown) { shown = on; setVisible(on); }
      };
      window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
      window.addEventListener('resize', check);
      check();

      stickyBtn.addEventListener('click', () => {
        const v = currentVariant();
        if (v && v.available && !atcBtn.disabled) {
          atcBtn.click();
          return;
        }
        const visible = el => el && el.offsetParent !== null && el.offsetHeight > 0;
        const notify = $$('.gw-button-widget, .gw-button-widget-container, [class*="krtbite"], [id*="krtbite"], [class*="restock"], .dbtfy-back-in-stock-container button', section).find(visible)
          || $$('.gw-button-widget, [class*="krtbite"], [class*="restock"]').find(visible)
          || target;
        notify.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const focusable = notify.matches('button, a, input') ? notify : $$('button, a, input', notify).find(visible);
        if (focusable) setTimeout(() => focusable.focus({ preventScroll: true }), 500);
      });
    }
  }

  function initVideos(root) {
    const vids = $$('[data-hm-reel]', root);
    if (!vids.length) return;
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const load = v => {
      if (v.dataset.loaded) return;
      $$('source[data-src]', v).forEach(s => { s.src = s.dataset.src; });
      v.dataset.loaded = '1';
      v.load();
    };
    const setSound = (v, on) => {
      v.muted = !on;
      const btn = $('[data-hm-reel-sound]', v.closest('.hm-reel'));
      if (btn) {
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.setAttribute('aria-label', btn.getAttribute('aria-label').replace(/^(Unmute|Mute)/, on ? 'Mute' : 'Unmute'));
      }
    };

    if ('IntersectionObserver' in window) {
      const nearIO = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { load(e.target); nearIO.unobserve(e.target); } }), { rootMargin: '300px 300px' });
      const playIO = new IntersectionObserver(es => es.forEach(e => {
        const v = e.target;
        if (e.isIntersecting && e.intersectionRatio >= 0.5) {
          load(v);
          if (!reduce || v.dataset.userPlay) v.play().catch(() => {});
        } else if (!document.fullscreenElement) {
          v.pause();
          if (!v.muted) setSound(v, false);
        }
      }), { threshold: [0, 0.5] });
      vids.forEach(v => { nearIO.observe(v); playIO.observe(v); });
    } else {
      vids.forEach(load);
    }

    root.addEventListener('click', e => {
      const card = e.target.closest('.hm-reel');
      if (!card) return;
      const v = $('[data-hm-reel]', card);
      load(v);
      v.dataset.userPlay = '1';
      if (e.target.closest('[data-hm-reel-fs]')) {
        vids.forEach(o => { if (o !== v) setSound(o, false); });
        setSound(v, true);
        v.controls = true;
        v.play().catch(() => {});
        if (v.requestFullscreen) v.requestFullscreen().catch(() => {});
        else if (v.webkitEnterFullscreen) v.webkitEnterFullscreen();
        return;
      }
      const turnOn = v.muted;
      vids.forEach(o => { if (o !== v) setSound(o, false); });
      setSound(v, turnOn);
      v.play().catch(() => { setSound(v, false); v.play().catch(() => {}); });
    });

    const exitFs = () => { if (!document.fullscreenElement) vids.forEach(v => { v.controls = false; }); };
    document.addEventListener('fullscreenchange', exitFs);
    vids.forEach(v => v.addEventListener('webkitendfullscreen', () => { v.controls = false; }));
  }

  const init = () => {
    $$('.product.section[data-section-type="product"]').forEach((s, i) => initProduct(s, i === 0));
    $$('[data-hm-videos]').forEach(initVideos);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
